import React from "react";
import TextArea from "./TextArea";
import styles from "./TopicInput.module.css";

interface TopicInputProps {
  topic: string;
  topicIcon: string;
  question: string;
  message: string;
  onMessageChange: (message: string) => void;
  onBackToTopics: () => void;
  onMessageInteractionStart?: () => void;
  disabled?: boolean;
}

const TopicInput: React.FC<TopicInputProps> = ({
  topic,
  topicIcon,
  question,
  message,
  onMessageChange,
  onBackToTopics,
  onMessageInteractionStart,
  disabled = false
}) => {
  return (
    <div role="region" aria-label="Message Input">
      <p className={styles.promptParagraph}>
        Say hello with a quick note! Pick a topic and share a little about yourself.
      </p>

      <div className={styles.container}>
        <div className={styles.topicHeader}>
          <div className={styles.iconWrapper} aria-hidden="true">
            <img src={topicIcon} alt="" className={styles.topicIcon} />
          </div>
          <div className={`${styles.topic} __staple--small`}>{topic}</div>
        </div>
        <div
          className={`${styles.question} eta`}
          role="heading"
          aria-level={4}
          dangerouslySetInnerHTML={{ __html: question }}
        />

        <TextArea
          value={message}
          onChange={onMessageChange}
          characterLimit={500}
          label={`Message for ${topic}`}
          onInteractionStart={onMessageInteractionStart}
          disabled={disabled}
        />

        <button
          onClick={onBackToTopics}
          className={`btn-link ${styles.backButton}`}
          aria-label="Return to topic selection">
          ← Back to topics
        </button>
      </div>
    </div>
  );
};

export default TopicInput;
